module.exports = __webpack_public_path__ + "img/car-icon.9a23ea18.png";